import { FC, useCallback } from 'react';

import Loading from '@/components/elements/Icon/Loading';
import ModalBase, { ModalBasicProps } from '@/components/layouts/Modal/Base';
import RaceBox from '@/components/layouts/Top/SingleraceList/RaceBox';
import { RaceProgram } from '@/lib/apollo/types/gen/graphql';
import { Campaign } from '@/lib/microcms/model';
import {
  filterSalePrograms,
  findCampaign,
  orderByOrderDeadline,
} from '@/lib/race/singlerace';
import { defaultTheme } from '@/utility/theme';

import { CurrentRaceWrapper, EmptyText, Title } from './style';

interface CurrentRaceModalProps extends ModalBasicProps {
  racePrograms: RaceProgram[];
  campaigns?: Campaign[];
  isLoading: boolean;
}

const CurrentRaceListModal: FC<CurrentRaceModalProps> = ({
  racePrograms,
  campaigns = [],
  isLoading,
  isOpen,
  handleClose,
}) => {
  const salePrograms = filterSalePrograms(racePrograms);

  const getCampaign = useCallback(
    (rp: RaceProgram) => findCampaign(rp, campaigns),
    [campaigns],
  );

  return (
    <ModalBase
      isOpen={isOpen}
      handleClose={() => handleClose()}
      desktopWidth="1000px"
      backgroundColor={defaultTheme.background.lightGray}
    >
      <Title>開催中のレース</Title>
      {isLoading ? (
        <EmptyText>
          <Loading
            width="48px"
            height="48px"
            color={defaultTheme.border.color.darkGray}
          />
        </EmptyText>
      ) : salePrograms.length ? (
        <CurrentRaceWrapper>
          {orderByOrderDeadline(salePrograms).map(rp => (
            <RaceBox
              raceProgram={rp}
              campaign={getCampaign(rp)}
              onLinkClick={() => handleClose()}
              key={rp.id}
            />
          ))}
        </CurrentRaceWrapper>
      ) : (
        <EmptyText>本日の開催はありません</EmptyText>
      )}
    </ModalBase>
  );
};

export default CurrentRaceListModal;
